(function () {
	$(function () {
		console.log('started!');

		for (let i in Page) Page[i]()
		for (let i in Common) Common[i]()
	});
})();
